// require('./bootstrap');
import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes.js'
import assetsUtils from './assetsUtils.js'
import { Field, Form, ErrorMessage, defineRule, FieldArray } from 'vee-validate' /* eslint-disable */
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import './assets/styles/_datepicker-theme.scss'
import './assets/styles/_form-components.scss'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleRight,
  faAngleDown,
  faEyeSlash,
  faEye,
  faMagnifyingGlass,
  faBell,
  faRightFromBracket,
  faCirclePlus,
  faFileWaveform,
  faCalendarDays,
  faBolt,
  faUnlockKeyhole,
  faClock,
  faHandshake,
  faScroll,
  faMagnifyingGlassPlus,
  faCheck,
  faFileLines,
  faFileWord,
  faFileUpload,
  faPaperclip,
  faCircleArrowLeft,
  faXmark,
  faBoxArchive,
  faFile,
  faFileSignature,
  faFileMedical,
  faBoltLightning,
  faCloudArrowUp,
  faAddressBook,
  faIndent,
  faBook,
  faFileArrowUp,
  faCircleCheck,
  faCircleXmark,
  faCalendarAlt,
} from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { VueDraggableNext } from 'vue-draggable-next'

library.add(
  faEye,
  faEyeSlash,
  faAngleRight,
  faAngleDown,
  faMagnifyingGlass,
  faBell,
  faRightFromBracket,
  faCirclePlus,
  faFileWaveform,
  faCalendarDays,
  faBolt,
  faUnlockKeyhole,
  faClock,
  faHandshake,
  faScroll,
  faMagnifyingGlassPlus,
  faCheck,
  faFileLines,
  faFileWord,
  faFileUpload,
  faPaperclip,
  faCircleArrowLeft,
  faXmark,
  faBoxArchive,
  faFile,
  faFileSignature,
  faFileMedical,
  faBoltLightning,
  faCloudArrowUp,
  faAddressBook,
  faIndent,
  faBook,
  faFileArrowUp,
  faCircleCheck,
  faCircleXmark,
  faCalendarAlt
)

const router = createRouter({
  history: createWebHistory(),
  routes: routes.routes,
})

router.beforeEach(async (to) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/login-internal', '/reset-password']
  const authRequired = !publicPages.includes(to.path)
  const checkLogin = localStorage.getItem('token') == 'undefined' || localStorage.getItem('token') == null
  if (authRequired && checkLogin) {
    return '/login'
  }
})
const app = createApp(App)
let portBackend =
  (window.location.origin == process.env.VUE_APP_PORT_LOCAL
    ? process.env.VUE_APP_BASE_URL_LOCAL
    : window.location.origin) + '/api/v1'
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL

app.use(router)
app.use(VueAxios, axios)
app.mount('#app')
app.provide('axios', app.config.globalProperties.axios)
app.component('Datepicker', Datepicker)
app.component('Field', Field)
app.component('Form', Form)
app.component('FieldArray', FieldArray)
app.component('ErrorMessage', ErrorMessage)
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('modalAlert', require('./components/modalAlert/index.vue').default)
app.component('loading', require('./components/loading/index.vue').default)
app.component('notification', require('./components/notificationSidebar').default)
app.component('pagination', require('./components/pagination/index.vue').default)
app.component('advance-search', require('./components/advanceSearch/index.vue').default)
app.component('draggable', VueDraggableNext)
app.config.globalProperties.backendport = process.env.VUE_APP_API_BASE_URL
app.config.globalProperties.assetsUtils = assetsUtils

app.config.globalProperties.baseURL = window.location.origin
let messageError = '*กรุณากรอกข้อมูล'
app.config.globalProperties.messageError = messageError

app.config.globalProperties.ruleSet = (data) => {
  app.config.globalProperties.rule = data
}

app.config.globalProperties.isBooleanSort = (data, boolean) => {
  if (typeof data == 'boolean') {
    if (data == boolean) return 'active'
    return ''
  } else {
    return ''
  }
}

app.config.globalProperties.sortText = (data, columns, sort, type) => {
  for (let item in sort) {
    if (item != columns) {
      sort[item] = ''
    }
  }
  sort[columns] = !sort[columns]
  if (type == 'number') {
    if (sort[columns]) {
      data = data.sort((a, b) => a[columns] - b[columns])
    } else {
      data = data.sort((a, b) => b[columns] - a[columns])
    }
  } else if (type == 'date') {
    if (sort[columns]) {
      data = data.sort(function (a, b) {
        return !a[columns] - !b[columns] || +b[columns] - +a[columns]
        // return new Date(b[columns]) - new Date(a[columns]);
      })
    } else {
      data = data.sort(function (a, b) {
        return !a[columns] - !b[columns] || +a[columns] - +b[columns]
        // return new Date(a[columns]) - new Date(b[columns]);
      })
    }
  } else {
    if (sort[columns]) {
      data = data.sort((a, b) => (a[columns] > b[columns] ? 1 : b[columns] > a[columns] ? -1 : 0))
    } else {
      data = data.sort((a, b) => (a[columns] < b[columns] ? 1 : b[columns] < a[columns] ? -1 : 0))
    }
  }
}

app.config.globalProperties.onInvalidSubmit = ({ errors }) => {
  const firstError = Object.keys(errors)[0]
  if (!firstError) return

  const elNormal = document.querySelector(`[name="${firstError}"]`)
  if (elNormal) {
    elNormal.focus()
  }

  const elSelect = document.querySelector(`[name="${firstError + 'Select'}"]`)
  if (elSelect) {
    elSelect.focus()
  }

  const elDate = document.querySelector(`[name="${firstError + 'Date'}"]`)
  if (elDate) {
    elDate.scrollIntoView({ block: 'center' })
  }

  const elTime = document.querySelector(`[name="${firstError + 'Time'}"]`)
  if (elTime) {
    elTime.scrollIntoView({ block: 'center' })
  }

  const elFieldShow = document.querySelector(`[name="FieldShow${firstError}"]`)
  if (elFieldShow) {
    elFieldShow.focus()
  }
}

let d = new Date()
let month = d.getMonth() + 1
let day = d.getDate()
let output = (day < 10 ? '0' : '') + day + '/' + (month < 10 ? '0' : '') + month + '/' + (d.getFullYear() + 543)
app.config.globalProperties.currentDate = output
window.axios = require('axios')

defineRule('required', (value) => {
  if (!value || !value.length) {
    return messageError
  }
  return true
})

defineRule('min', (value, [min]) => {
  if (value && value.length < min) {
    return `Should be at least ${min} characters`
  }
  return true
})

defineRule('email', (value) => {
  if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
    return '*กรุณากรอกอีเมลที่ถูกต้อง'
  }
  return true
})

defineRule('password', (value) => {
  if (!value.match('^(?=.*[0-9])(?=.*[A-Za-z]).{8,}$')) {
    return 'use at least 8 characters and include a number and a letter'
  }
  return true
})

defineRule('confirmed', (value, [other]) => {
  if (value !== other) {
    return `*กรุณากรอกรหัสผ่านใหม่ให้ตรงกัน`
  }
  return true
})
